import React, { useState, useEffect, useRef } from 'react';
import Sidebar from '../components/Sidebar';
import ReactQuill from 'react-quill';
import 'quill/dist/quill.snow.css';import {
  Search,
  SlidersHorizontal,
  Download,
  Menu,
  MapPin,
  Plus,
  Calendar,
  Clock,
  Save,
  X,
  Check,
  AlertCircle,
  Trash2,
  Edit,
  Eye,
  MoreVertical,
  Filter,
  Users,
  DollarSign,
  Upload,
  Link as LinkIcon,
  ChevronLeft,
  ChevronRight,
  ChevronDown,
  Bold,
  Italic,
  Underline,
  AlignLeft,
  AlignCenter,
  AlignRight,
  AlignJustify,
  List,
  ListOrdered,
  Undo,
  Redo,
} from 'lucide-react';
import imageApi from '../services/imageApi';

import DetailsTab from './DetailsTab';
import FeaturesTab from './FeaturesTab';
import LimitationsTab from './LimitationsTab';
import RatesTab from './RatesTab';

const BASE_URL = 'https://faas-sgp1-18bc02ac.doserverless.co/api/v1/web/fn-eabd0529-e853-4bfe-85de-7e0fb90bd150/resource';

function getAuthHeaders() {
  const token = (typeof sessionStorage !== 'undefined' && sessionStorage.getItem('access_token'))
    || (typeof localStorage !== 'undefined' && localStorage.getItem('access_token'));
  return token ? { Authorization: `Bearer ${token}` } : {};
}

const apiRequest = async (endpoint, method = 'GET', data = null) => {
  const url = `${BASE_URL}${endpoint}`;

  const options = {
    method,
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(), 
    },
  };

  if (data && (method === 'POST' || method === 'PUT' || method === 'PATCH')) {
    options.body = JSON.stringify(data);
  }

  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('API request error:', error);
    throw error;
  }
};

const fetchMongoData = async (mongoId) => {
  try {
    const response = await apiRequest(`/getMongoDbResourceData/${mongoId}`, 'GET');
    return response;
  } catch (error) {
    console.error('Error fetching mongo data:', error);
    return null;
  }
};




function DeleteConfirmModal({ isOpen, onClose, onConfirm, resourceName, resourceCount }) {
  const [isDeleting, setIsDeleting] = useState(false);

  if (!isOpen) return null;

  const handleConfirm = async () => {
    setIsDeleting(true);
    await onConfirm();
    setIsDeleting(false);
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="p-6">
          <div className="flex items-center mb-4">
            <div className="flex-shrink-0 w-10 h-10 mx-auto bg-red-100 rounded-full flex items-center justify-center">
              <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
          </div>

          <div className="text-center">
            <h3 className="text-lg font-medium text-gray-900 mb-2">
              Delete {resourceCount > 1 ? `${resourceCount} Resources` : 'Resource'}
            </h3>
            <p className="text-sm text-gray-500 mb-6">
              {resourceCount > 1
                ? `Are you sure you want to delete ${resourceCount} selected resources? This action cannot be undone.`
                : `Are you sure you want to delete "${resourceName}"? This action cannot be undone.`
              }
            </p>

            <div className="flex gap-3 justify-center">
              <button
                onClick={onClose}
                disabled={isDeleting}
                className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                Cancel
              </button>
              <button
                onClick={handleConfirm}
                disabled={isDeleting}
                className="px-4 py-2 bg-red-600 text-white rounded-lg text-sm font-medium hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
              >
                {isDeleting ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                    Deleting...
                  </>
                ) : (
                  <>Delete {resourceCount > 1 ? 'All' : 'Resource'}</>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
function AddResourceModal({ isOpen, onClose, onSuccess }) {
  const [currentStep, setCurrentStep] = useState(1);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [uploadingImage, setUploadingImage] = useState(false);

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  };

  const [formData, setFormData] = useState({
    resource_name: '',
    category: 'meeting_room',
    capacity: 10,
    start_date: getTodayDate(),
    photo_url: '',
    description: '',
   
    defined_timings: [
      { weekday: 'monday', start_time: '09:00:00', end_time: '18:00:00', enabled: true },
      { weekday: 'tuesday', start_time: '09:00:00', end_time: '18:00:00', enabled: true },
      { weekday: 'wednesday', start_time: '09:00:00', end_time: '18:00:00', enabled: true },
      { weekday: 'thursday', start_time: '09:00:00', end_time: '18:00:00', enabled: true },
      { weekday: 'friday', start_time: '09:00:00', end_time: '18:00:00', enabled: true },
      { weekday: 'saturday', start_time: '09:00:00', end_time: '18:00:00', enabled: false },
      { weekday: 'sunday', start_time: '09:00:00', end_time: '18:00:00', enabled: false }
    ],
    max_duration: { value: 10, unit: 'hours' },
    min_duration: { value: 1, unit: 'hours' },
    duration_interval: { value: 15, unit: 'minutes' },
    email_confirmation: true,
    rates: [],
    resource_plans: [],
    features: {
      standing_desk: false,
      quiet_zone: false,
      privacy_screen: false,
      soundproof_room: false,
      catering: false,
      tea_coffee: false,
      drinks: false
    },
    amenities: {
      projector: false,
      internet: false,
      wireless_charger: false,
      conference_phone: false,
      standard_phone: false,
      whiteboard: false,
      flip_chart: false,
      large_display: false,
      video_conferencing: false
    },
    security: {
      locked_securely: false,
      cctv: false,
      voice_recorder: false
    }
  });

  const quillModules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      ['bold', 'italic', 'underline'],
      [{ color: [] }, { background: [] }],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ align: [] }],
      ['link', 'clean'],
    ],
  };
  
  const quillFormats = [
    'header', 'bold', 'italic', 'underline', 'color', 'background',
    'list', 'bullet', 'align', 'link',
  ];

  const [availablePlans] = useState([
    { plan_name: 'Enterprise Suite' },
    { plan_name: 'JustDesk Dedicated' },
    { plan_name: 'JustDesk Unlimited' },
    { plan_name: 'Private Office No View' },
    { plan_name: 'Private Office with View' },
    { plan_name: 'Virtual Office' },
  ]);

  const categoryOptions = [
    { value: 'big_meeting_room', label: 'Big Meeting Room' },
    { value: 'small_meeting_room', label: 'Small Meeting Room' },
    { value: 'collaboration_room', label: 'Collaboration Room' },
    { value: 'others', label: 'Others' },   // added "Others" category
  
  ];

  if (!isOpen) return null;

  const handleNext = () => {
    setError(null);

    if (currentStep === 1) {
      if (!formData.resource_name.trim()) {
        setError('Resource name is required');
        return;
      }
      if (!formData.category) {
        setError('Category is required');
        return;
      }
    }

    if (currentStep === 2) {
      const enabledTimings = formData.defined_timings.filter(t => t.enabled);
      if (enabledTimings.length === 0) {
        setError('Please enable at least one day');
        return;
      }
    }
  

    setCurrentStep(prev => Math.min(prev + 1, 3));
  };

  const handleBack = () => {
    setError(null);
    setCurrentStep(prev => Math.max(prev - 1, 1));
  };

  const updateFormData = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const updateTiming = (index, field, value) => {
    const newTimings = [...formData.defined_timings];
    newTimings[index] = { ...newTimings[index], [field]: value };
    setFormData(prev => ({ ...prev, defined_timings: newTimings }));
  };

  const addRate = () => {
    const newRate = {
      price_name: 'New Rate',
      description: '',
      price: 0,
      renewal_type: 'every hour',
      userType: 'Both',
      
    };
    setFormData(prev => ({
      ...prev,
      rates: [...prev.rates, newRate]
    }));
  };

  const updateRate = (index, field, value) => {
    const newRates = [...formData.rates];
    newRates[index] = { ...newRates[index], [field]: value };
    setFormData(prev => ({ ...prev, rates: newRates }));
  };

  const removeRate = (index) => {
    setFormData(prev => ({
      ...prev,
      rates: prev.rates.filter((_, i) => i !== index)
    }));
  };

  const togglePlan = (planName) => {
    const exists = formData.resource_plans.find(p => p.plan_name === planName);
    if (exists) {
      setFormData(prev => ({
        ...prev,
        resource_plans: prev.resource_plans.filter(p => p.plan_name !== planName)
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        resource_plans: [...prev.resource_plans, { plan_name: planName }]
      }));
    }
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      try {
        setUploadingImage(true);
        setError(null);
        console.log('Uploading image:', file);
        const result = await imageApi.uploadImage(file);
        console.log('Upload result:', result);
        const imageUrl = result.url || result.imageUrl || result.image_url;
        console.log('Extracted image URL:', imageUrl);
        if (imageUrl) {
          updateFormData('photo_url', imageUrl);
          console.log('Updated form data with photo_url:', imageUrl);
        } else {
          setError('Failed to get image URL from upload response');
        }
      } catch (err) {
        console.error('Image upload failed:', err);
        setError('Failed to upload image: ' + err.message);
      } finally {
        setUploadingImage(false);
      }
    }
  };

  const handleSubmit = async () => {
    try {
      setIsSubmitting(true);
      setError(null);

    

      // HH:MM:SS format
      const enabledTimings = formData.defined_timings
        .filter(t => t.enabled)
        .map(({ enabled, ...rest }) => ({
          ...rest,
          start_time: rest.start_time.length === 5 ? `${rest.start_time}:00` : rest.start_time,
          end_time: rest.end_time.length === 5 ? `${rest.end_time}:00` : rest.end_time
        }));

      const convertToISO = (value, unit) => {
        if (unit === 'hours') return `PT${value}H`;
        if (unit === 'minutes') return `PT${value}M`;
        if (unit === 'days') return `PT${value * 24}H`;
        return `PT${value}M`;
      };

      const requestBody = {
        defined_timings: enabledTimings,
        max_duration: convertToISO(formData.max_duration.value, formData.max_duration.unit),
        min_duration: convertToISO(formData.min_duration.value, formData.min_duration.unit),
        duration_interval: convertToISO(formData.duration_interval.value, formData.duration_interval.unit),
        resource_name: formData.resource_name,
        start_date: formData.start_date,
        photo_url: formData.photo_url || 'https://example.com/default-resource.jpg',
        capacity: parseInt(formData.capacity) || 10,
        resource_details: {
          description: formData.description || 'No description provided'
        },
        email_confirmation: formData.email_confirmation,
        resource_plans: formData.resource_plans,
        category: formData.category,
        location_id: '80c10e0e-3ead-4740-a2a6-574354bb9a77',
        rates: formData.rates.map(rate => ({  
          price_name: rate.price_name,
          description: rate.description,
          price: parseFloat(rate.price) || 0,
          renewal_type: rate.renewal_type,
          userType: rate.userType || 'Both' 
        })),
        metadata: {
          features: Object.entries(formData.features).reduce((acc, [key, value]) => {
            if (value) {  
              acc[key] = { enabled: true };
            }
            return acc;
          }, {}),
          amenities: Object.entries(formData.amenities).reduce((acc, [key, value]) => {
            if (value) {  
              acc[key] = { enabled: true };
            }
            return acc;
          }, {}),
          security: Object.entries(formData.security).reduce((acc, [key, value]) => {
            if (value) {  
              acc[key] = { enabled: true };
            }
            return acc;
          }, {}),
        }
      };

      console.log('Creating resource with data:', requestBody);

      const response = await apiRequest('/createResource', 'POST', requestBody);
      console.log('Resource created successfully:', response);

      // Extract mongo_id from response
      const mongoId = response.resource_details?.mongo_id;
      console.log('MongoDB ID:', mongoId);

      // success message
      const successMessage = document.createElement('div');
      successMessage.className = 'fixed top-4 right-4 bg-[#79C485] text-white px-6 py-3 rounded-lg shadow-lg z-50';
      successMessage.textContent = 'Resource created successfully!';
      document.body.appendChild(successMessage);

      setTimeout(() => {
        if (successMessage.parentNode) {
          successMessage.parentNode.removeChild(successMessage);
        }
      }, 3000);

      // reset form
      setFormData({
        resource_name: '',
        category: 'meeting_room',
        capacity: 10,
        start_date: getTodayDate(),
        photo_url: '',
        description: '',
    
        defined_timings: [
          { weekday: 'monday', start_time: '09:00:00', end_time: '18:00:00', enabled: true },
          { weekday: 'tuesday', start_time: '09:00:00', end_time: '18:00:00', enabled: true },
          { weekday: 'wednesday', start_time: '09:00:00', end_time: '18:00:00', enabled: true },
          { weekday: 'thursday', start_time: '09:00:00', end_time: '18:00:00', enabled: true },
          { weekday: 'friday', start_time: '09:00:00', end_time: '18:00:00', enabled: true },
          { weekday: 'saturday', start_time: '09:00:00', end_time: '18:00:00', enabled: false },
          { weekday: 'sunday', start_time: '09:00:00', end_time: '18:00:00', enabled: false }
        ],
        max_duration: { value: 10, unit: 'hours' },
        min_duration: { value: 1, unit: 'hours' },
        duration_interval: { value: 15, unit: 'minutes' },
        email_confirmation: true,
        rates: [],
        resource_plans: [],
        features: {
          standing_desk: false,
          quiet_zone: false,
          privacy_screen: false,
          soundproof_room: false,
          catering: false,
          tea_coffee: false,
          drinks: false
        },
        amenities: {
          projector: false,
          internet: false,
          wireless_charger: false,
          conference_phone: false,
          standard_phone: false,
          whiteboard: false,
          flip_chart: false,
          large_display: false,
          video_conferencing: false
        },
        security: {
          locked_securely: false,
          cctv: false,
          voice_recorder: false
        }
      });

      setCurrentStep(1);

      onClose();
      if (onSuccess) {
        await onSuccess();
      }
    } catch (err) {
      console.error('Error creating resource:', err);
      setError(err.message || 'Failed to create resource');
    } finally {
      setIsSubmitting(false);
    }
  };


  const handleClose = () => {
    setCurrentStep(1);
    setError(null);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-4xl w-full max-h-[90vh] overflow-hidden flex flex-col">
        <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
          <div>
            <h2 className="text-xl font-semibold text-gray-900">Add New Resource</h2>
            <p className="text-sm text-gray-500 mt-1">Step {currentStep} of 3</p>
          </div>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="px-6 py-4 border-b border-gray-200">
          <div className="flex items-center justify-between mb-2">
            <span className={`text-sm font-medium ${currentStep >= 1 ? 'text-blue-600' : 'text-gray-400'}`}>
              Basic Info
            </span>
            <span className={`text-sm font-medium ${currentStep >= 2 ? 'text-blue-600' : 'text-gray-400'}`}>
              Availability & Features
            </span>
            <span className={`text-sm font-medium ${currentStep >= 3 ? 'text-blue-600' : 'text-gray-400'}`}>
              Pricing & Plans
            </span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div
              className="bg-blue-600 h-2 rounded-full transition-all duration-300"
              style={{ width: `${(currentStep / 3) * 100}%` }}
            />
          </div>
        </div>

        {error && (
          <div className="mx-6 mt-4 p-4 bg-red-50 border border-red-200 rounded-lg flex items-start gap-3">
            <AlertCircle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
            <div className="flex-1">
              <p className="text-sm font-medium text-red-800">Error</p>
              <p className="text-sm text-red-700 mt-1">{error}</p>
            </div>
          </div>
        )}

        <div className="flex-1 overflow-y-auto px-6 py-6">
          {currentStep === 1 && (
            <div className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Resource Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  value={formData.resource_name}
                  onChange={(e) => updateFormData('resource_name', e.target.value)}
                  placeholder="e.g., Conference Room A"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Category <span className="text-red-500">*</span>
                </label>
                <select
                  value={formData.category}
                  onChange={(e) => updateFormData('category', e.target.value)}
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                >
                  {categoryOptions.map(option => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Capacity
                  </label>
                  <input
                    type="number"
                    value={formData.capacity}
                    onChange={(e) => updateFormData('capacity', e.target.value)}
                    min="1"
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Available From
                  </label>
                  <input
                    type="date"
                    value={formData.start_date}
                    onChange={(e) => updateFormData('start_date', e.target.value)}
                    className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Photo Upload
                </label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleFileUpload}
                  disabled={uploadingImage}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
                />
                <p className="text-xs text-gray-500 mt-1">
                  Upload a photo for this resource (optional)
                </p>

                {uploadingImage && (
                  <div className="mt-2 flex items-center gap-2 text-sm text-blue-600">
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-600"></div>
                    <span>Uploading image...</span>
                  </div>
                )}

                {formData.photo_url && !uploadingImage && (
                  <div className="mt-2">
                    <img
                      src={formData.photo_url}
                      alt="Preview"
                      className="w-32 h-20 object-cover rounded border border-gray-300"
                    />
                  </div>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Description
                </label>
                <textarea
                  value={formData.description}
                  onChange={(e) => updateFormData('description', e.target.value)}
                  placeholder="Describe the resource..."
                  rows="4"
                  className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>
          )}

          {currentStep === 2 && (
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-4">Operating Hours</h3>
                <div className="space-y-3">
                  {formData.defined_timings.map((timing, index) => (
                    <div key={timing.weekday} className="flex items-center gap-4 p-4 border border-gray-200 rounded-lg">
                      <input
                        type="checkbox"
                        checked={timing.enabled}
                        onChange={(e) => updateTiming(index, 'enabled', e.target.checked)}
                        className="w-4 h-4"
                      />
                      <span className="w-24 font-medium capitalize">{timing.weekday}</span>
                      <div className="flex items-center gap-2 flex-1">
                        <input
                          type="time"
                          value={timing.start_time}
                          onChange={(e) => updateTiming(index, 'start_time', e.target.value)}
                          disabled={!timing.enabled}
                          className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
                        />
                        <span className="text-gray-500">to</span>
                        <input
                          type="time"
                          value={timing.end_time}
                          onChange={(e) => updateTiming(index, 'end_time', e.target.value)}
                          disabled={!timing.enabled}
                          className="px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100"
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-4">Booking Duration Settings</h3>
                <div className="space-y-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Maximum Duration
                    </label>
                    <div className="flex items-center gap-2">
                      <input
                        type="number"
                        value={formData.max_duration.value}
                        onChange={(e) => updateFormData('max_duration', {
                          ...formData.max_duration,
                          value: parseInt(e.target.value) || 0
                        })}
                        min="1"
                        className="w-32 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                      <select
                        value={formData.max_duration.unit}
                        onChange={(e) => updateFormData('max_duration', {
                          ...formData.max_duration,
                          unit: e.target.value
                        })}
                        className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                      >
                        <option value="minutes">Minutes</option>
                        <option value="hours">Hours</option>
                        <option value="days">Days</option>
                      </select>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Minimum Duration
                    </label>
                    <div className="flex items-center gap-2">
                      <input
                        type="number"
                        value={formData.min_duration.value}
                        onChange={(e) => updateFormData('min_duration', {
                          ...formData.min_duration,
                          value: parseInt(e.target.value) || 0
                        })}
                        min="1"
                        className="w-32 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                      <select
                        value={formData.min_duration.unit}
                        onChange={(e) => updateFormData('min_duration', {
                          ...formData.min_duration,
                          unit: e.target.value
                        })}
                        className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                      >
                        <option value="minutes">Minutes</option>
                        <option value="hours">Hours</option>
                        <option value="days">Days</option>
                      </select>
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Duration Interval (Booking Time Slots)
                    </label>
                    <div className="flex items-center gap-2">
                      <input
                        type="number"
                        value={formData.duration_interval.value}
                        onChange={(e) => updateFormData('duration_interval', {
                          ...formData.duration_interval,
                          value: parseInt(e.target.value) || 0
                        })}
                        min="0"
                        max="45"
                        step="15"
                        className="w-32 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                      />
                      <select
                        value={formData.duration_interval.unit}
                        onChange={(e) => updateFormData('duration_interval', {
                          ...formData.duration_interval,
                          unit: e.target.value
                        })}
                        className="px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                      >
                        <option value="minutes">Minutes</option>
                        <option value="hours">Hours</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-4">Features</h3>
                <div className="grid grid-cols-3 gap-4">
                  {Object.entries(formData.features).map(([key, value]) => (
                    <label key={key} className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        checked={value}
                        onChange={(e) => updateFormData('features', {
                          ...formData.features,
                          [key]: e.target.checked
                        })}
                        className="w-4 h-4 text-blue-600"
                      />
                      <span className="text-sm capitalize">{key.replace(/_/g, ' ')}</span>
                    </label>
                  ))}
                </div>
              </div>

              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-4">Amenities</h3>
                <div className="grid grid-cols-3 gap-4">
                  {Object.entries(formData.amenities).map(([key, value]) => (
                    <label key={key} className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        checked={value}
                        onChange={(e) => updateFormData('amenities', {
                          ...formData.amenities,
                          [key]: e.target.checked
                        })}
                        className="w-4 h-4 text-blue-600"
                      />
                      <span className="text-sm capitalize">{key.replace(/_/g, ' ')}</span>
                    </label>
                  ))}
                </div>
              </div>

              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-4">Security</h3>
                <div className="grid grid-cols-3 gap-4">
                  {Object.entries(formData.security).map(([key, value]) => (
                    <label key={key} className="flex items-center gap-2">
                      <input
                        type="checkbox"
                        checked={value}
                        onChange={(e) => updateFormData('security', {
                          ...formData.security,
                          [key]: e.target.checked
                        })}
                        className="w-4 h-4 text-blue-600"
                      />
                      <span className="text-sm capitalize">{key.replace(/_/g, ' ')}</span>
                    </label>
                  ))}
                </div>
              </div>
            </div>
          )}

          {currentStep === 3 && (
            <div className="space-y-6">
              <div>
                <div className="flex items-center justify-between mb-4">
                  <h3 className="text-lg font-medium text-gray-900">Pricing Rates</h3>
                  <button
                    onClick={addRate}
                    className="flex items-center gap-2 px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm"
                  >
                    <Plus className="w-4 h-4" />
                    Add Rate
                  </button>
                </div>

                {formData.rates.length === 0 ? (
                  <div className="text-center py-8 border-2 border-dashed border-gray-300 rounded-lg">
                    <DollarSign className="w-12 h-12 text-gray-400 mx-auto mb-2" />
                    <p className="text-gray-500">No rates added yet</p>
                    <p className="text-sm text-gray-400 mt-1">Click "Add Rate" to create pricing</p>
                  </div>
                ) : (
                  <div className="space-y-3">
                    {formData.rates.map((rate, index) => (
                      <div key={index} className="p-4 border border-gray-200 rounded-lg">
                       <div className="grid grid-cols-3 gap-4 mb-3"> 
                          <div>
                            <label className="block text-xs font-medium text-gray-700 mb-1">
                              Rate Name
                            </label>
                            <input
                              type="text"
                              value={rate.price_name}
                              onChange={(e) => updateRate(index, 'price_name', e.target.value)}
                              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                          </div>
                          <div>
                            <label className="block text-xs font-medium text-gray-700 mb-1">
                              Renewal Type
                            </label>
                            <select
                              value={rate.renewal_type}
                              onChange={(e) => updateRate(index, 'renewal_type', e.target.value)}
                              className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            >
                              <option value="every hour">Every Hour</option>
                              <option value="every day">Every Day</option>
                              <option value="every week">Every Week</option>
                            </select>
                          </div>
                          <div>
    <label className="block text-xs font-medium text-gray-700 mb-1">
      User Type
    </label>
    <select
      value={rate.userType}
      onChange={(e) => updateRate(index, 'userType', e.target.value)}
      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
    >
      <option value="Both">Both</option>
      <option value="Contacts Only">Contacts Only</option>
      <option value="Members Only">Members Only</option>
    </select>
  </div>
   
                        </div>

                        <div className="mb-3">
                          <label className="block text-xs font-medium text-gray-700 mb-1">
                            Description
                          </label>
                          <input
                            type="text"
                            value={rate.description}
                            onChange={(e) => updateRate(index, 'description', e.target.value)}
                            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                          />
                        </div>

                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-2">
                            <label className="block text-xs font-medium text-gray-700">
                              Price
                            </label>
                            <div className="flex items-center gap-1">
                              <span className="text-gray-500">IDR</span>
                              <input
                                type="number"
                                value={rate.price}
                                onChange={(e) => updateRate(index, 'price', parseInt(e.target.value) || 0)}
                                min="0"
                                step="1"
                                className="w-24 px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                              />
                            </div>
                          </div>
                          <button
                            onClick={() => removeRate(index)}
                            className="text-red-600 hover:text-red-700 p-2"
                          >
                            <Trash2 className="w-4 h-4" />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div>
                <h3 className="text-lg font-medium text-gray-900 mb-1">Resource Plans</h3>                <p className="text-sm text-gray-500 mb-4">
                  Select which plans can access this resource
                </p>
                <div className="grid grid-cols-2 gap-3">
                  {availablePlans.map(plan => (
                    <label
                      key={plan.plan_name}
                      className={`flex items-center gap-3 p-4 border-2 rounded-lg cursor-pointer transition-all ${formData.resource_plans.find(p => p.plan_name === plan.plan_name)
                          ? 'border-blue-500 bg-blue-50'
                          : 'border-gray-200 hover:border-gray-300'
                        }`}
                    >
                      <input
                        type="checkbox"
                        checked={!!formData.resource_plans.find(p => p.plan_name === plan.plan_name)}
                        onChange={() => togglePlan(plan.plan_name)}
                        className="w-4 h-4"
                        required
                      />
                      <span className="font-medium">{plan.plan_name}</span>
                    </label>
                  ))}
                </div>
              </div>

              <div>
                <label className="flex items-center gap-3 p-4 border border-gray-200 rounded-lg cursor-pointer">
                  <input
                    type="checkbox"
                    checked={formData.email_confirmation}
                    onChange={(e) => updateFormData('email_confirmation', e.target.checked)}
                    className="w-4 h-4"
                  />
                  <div>
                    <span className="font-medium">Email Confirmation</span>
                    <p className="text-sm text-gray-500">Send confirmation emails for bookings</p>
                  </div>
                </label>
              </div>

          



             



            </div>
          )}
        </div>

        <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-between">
          <button
            onClick={handleBack}
            disabled={currentStep === 1}
            className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <ChevronLeft className="w-4 h-4" />
            Back
          </button>

          <div className="flex items-center gap-3">
            <button
              onClick={handleClose}
              className="px-4 py-2 border border-gray-300 rounded-lg text-sm font-medium hover:bg-gray-50"
            >
              Cancel
            </button>

            {currentStep < 3 ? (
              <button
                onClick={handleNext}
                className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700"
              >
                Next
                <ChevronRight className="w-4 h-4" />
              </button>
            ) : (
              <button
                onClick={handleSubmit}
                disabled={isSubmitting}
                className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700 disabled:opacity-50"
              >
                {isSubmitting ? (
                  <>
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                    Creating...
                  </>
                ) : (
                  <>
                    <Check className="w-4 h-4" />
                    Create Resource
                  </>
                )}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

// ResourceDetail comp tabs
function ResourceDetail({ resource, onBack, onUpdate }) {
  const [activeTab, setActiveTab] = useState('details');
  const [currentResource, setCurrentResource] = useState(resource);





  useEffect(() => {
    if (resource && resource.id) {
      console.log('ResourceDetail: Component mounted or resource changed, refreshing data');
      refreshResourceData();
    }
  }, [resource.id]);

  const refreshResourceData = async () => {
    try {
      console.log('Refreshing resource data for:', currentResource.name);
  
      const response = await apiRequest('/viewAllResource', 'GET');
      const foundResource = response.data?.find(r => r.id === currentResource.id);
  
      if (foundResource) {
        console.log('Raw updated resource from API:', foundResource);
  
        const metadata = foundResource.metadata || {};
        const imageUrl = foundResource.metadata?.photo_url || null;
  
        let mongoFeatures = {};
        let mongoAmenities = {};
        let mongoSecurity = {};
        let mongoId = null;
        let mongoData = null; 
  
        if (foundResource.mongo_id) {
          mongoId = foundResource.mongo_id;
          mongoData = await fetchMongoData(mongoId); 
          if (mongoData) {
            mongoFeatures = mongoData.features || {};
            mongoAmenities = mongoData.amenities || {};
            mongoSecurity = mongoData.security || {};
        
          }
        }
  
        const transformedResource = {
          id: foundResource.id,
          name: foundResource.name,
          location: 'Continuum',
          image: imageUrl,
          type: 'Free of Charge - Continuum',
          category: metadata.category || 'meeting_room',
          mongo_id: mongoId,
          originalData: foundResource,

          details: {
            resourceDetails: metadata.resource_details?.description || '',
            features: mongoFeatures,
            amenities: mongoAmenities,
            security: mongoSecurity
          },
          limitations: {
            capacity: metadata.capacity || 10,
            limitGuests: false,
            timeSlots: [],
            availableFor: 'All Customers',
            teams: [],
            restrictTeams: 'Members of any team'
          },
          rates: metadata.rates || [],
          defined_timings: foundResource.defined_timings || [],
          max_duration: foundResource.max_duration || 'PT10H',
          min_duration: foundResource.min_duration || 'PT1H',
          duration_interval: foundResource.duration_interval || 'PT15M',
          start_date: foundResource.start_date || new Date().toISOString().split('T')[0],
          email_confirmation: metadata.email_confirmation || false
        };
  
        setCurrentResource(transformedResource);
        console.log('Updated current resource:', transformedResource);
  
        if (onUpdate) {
          console.log('Calling parent onUpdate to refresh resource list');
          await onUpdate();
        }
      }
    } catch (err) {
      console.error('Error refreshing resource data:', err);
    }
  };

  const tabs = [
    { id: 'details', label: 'Details', icon: Menu },
    { id: 'features', label: 'Features', icon: SlidersHorizontal },
    { id: 'limitations', label: 'Limitations', icon: SlidersHorizontal },
    { id: 'rates', label: 'Rates', icon: null },
  ];

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      <Sidebar currentPath="/resources" />
      <div className="flex-1 flex flex-col overflow-hidden">
        <main className="flex-1 overflow-y-auto bg-gray-50">
          <div className="p-8">
            <div className="mb-6">
              <button onClick={onBack} className="text-blue-600 hover:text-blue-700 mb-2 text-sm">
                ← Back to Resources
              </button>
              <div className="flex items-center justify-between">
                <div>
                  <h1 className="text-2xl font-semibold text-gray-900 mb-1">{currentResource.name}</h1>
                  <p className="text-sm text-gray-500">{currentResource.location}</p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-sm border border-gray-200">
              <div className="border-b border-gray-200">
                <div className="flex">
                  {tabs.map((tab) => (
                    <button
                      key={tab.id}
                      onClick={() => setActiveTab(tab.id)}
                      className={`px-6 py-4 text-sm font-medium border-b-2 transition-colors ${activeTab === tab.id
                          ? 'border-blue-600 text-blue-600'
                          : 'border-transparent text-gray-500 hover:text-gray-700'
                        }`}
                    >
                      {tab.label}
                    </button>
                  ))}
                </div>
              </div>

              <div className="p-6">
                {activeTab === 'details' && (
                  <DetailsTab resource={currentResource} onUpdate={refreshResourceData} />
                )}
                {activeTab === 'features' && (
                  <FeaturesTab resource={currentResource} onUpdate={refreshResourceData} />
                )}
                {activeTab === 'limitations' && (
                  <LimitationsTab resource={currentResource} onUpdate={refreshResourceData} />
                )}
                {activeTab === 'rates' && (
                  <RatesTab resource={currentResource} onUpdate={refreshResourceData} />
                )}
             
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
// Main Resources Component
export default function Resources() {
  const [selectedResource, setSelectedResource] = useState(null);
  const [selectedForBulk, setSelectedForBulk] = useState([]);
  const [showBulkMenu, setShowBulkMenu] = useState(false);
  const [resources, setResources] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteResourceInfo, setDeleteResourceInfo] = useState({ name: '', count: 0 });
  const [sortBy, setSortBy] = useState('name'); // 'name', 'category', 'capacity', 'date'
  const [sortOrder, setSortOrder] = useState('asc'); // 'asc' or 'desc'
  const [showSortMenu, setShowSortMenu] = useState(false);
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  const sortMenuRef = useRef(null);
  const bulkMenuRef = useRef(null);

  useEffect(() => {
    fetchResources();
  }, []);

  const fetchResources = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await apiRequest('/viewAllResource', 'GET');

      const transformedResources = await Promise.all(
        (response.data || []).map(async (resource) => { 
          const metadata = resource.metadata || {};
          const imageUrl = resource.metadata?.photo_url || null;

          // Fetch MongoDB data for features/amenities/security
          let mongoFeatures = {};
          let mongoAmenities = {};
  
          let mongoSecurity = {};
          let mongoId = null;

          if (resource.mongo_id) {
            mongoId = resource.mongo_id;
            const mongoData = await fetchMongoData(mongoId);
            if (mongoData) {
              mongoFeatures = mongoData.features || {};
              mongoAmenities = mongoData.amenities || {};
              mongoSecurity = mongoData.security || {};
              
            }
          }

          return {
            id: resource.id,
            name: resource.name,
            location: 'Continuum',
            image: imageUrl,
            type: 'Free of Charge - Continuum',
            category: metadata.category || 'meeting_room',
            mongo_id: mongoId, // Store mongo_id
            originalData: resource,
         
            
            details: {
              resourceDetails: metadata.resource_details?.description || '',
              features: mongoFeatures,
              amenities: mongoAmenities,
              security: mongoSecurity
            },
            limitations: {
              capacity: metadata.capacity || 10,
              limitGuests: false,
              timeSlots: [],
              availableFor: 'All Customers',
              teams: [],
              restrictTeams: 'Members of any team'
            },
            rates: metadata.rates || [],
            defined_timings: resource.defined_timings || [],
            max_duration: resource.max_duration || 'PT10H',
            min_duration: resource.min_duration || 'PT1H',
            duration_interval: resource.duration_interval || 'PT15M',
            start_date: resource.start_date || new Date().toISOString().split('T')[0],
            email_confirmation: metadata.email_confirmation || false
          };
        })
      );

      setResources(transformedResources);
    } catch (err) {
      setError(err.message);
      console.error('Failed to fetch resources:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteClick = () => {
    if (selectedForBulk.length === 0) return;

    const resourceNames = selectedForBulk.map(id => {
      const resource = resources.find(r => r.id === id);
      return resource ? resource.name : 'Unknown';
    });

    setDeleteResourceInfo({
      name: resourceNames.length === 1 ? resourceNames[0] : '',
      count: selectedForBulk.length
    });
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      console.log('Starting delete process for resources:', selectedForBulk);

      for (const id of selectedForBulk) {
        console.log('Deleting resource with ID:', id);
        try {
          const response = await apiRequest(`/deleteResource/${id}`, 'DELETE');
          console.log('Delete response for', id, ':', response);
        } catch (deleteErr) {
          console.error('Failed to delete resource', id, ':', deleteErr);
        }
      }

      console.log('Delete process completed');

      await fetchResources();
      setSelectedForBulk([]);
      setShowBulkMenu(false);
      setShowDeleteModal(false);

    } catch (err) {
      console.error('Delete error:', err);
    }
  };

  const getSortedResources = () => {
    const sorted = [...resources].sort((a, b) => {
      let aVal, bVal;

      switch (sortBy) {
        case 'name':
          aVal = a.name.toLowerCase();
          bVal = b.name.toLowerCase();
          break;
        case 'category':
          aVal = a.category.toLowerCase();
          bVal = b.category.toLowerCase();
          break;
        case 'capacity':
          aVal = a.limitations.capacity;
          bVal = b.limitations.capacity;
          break;
        case 'date':
          aVal = new Date(a.start_date);
          bVal = new Date(b.start_date);
          break;
        default:
          return 0;
      }

      if (aVal < bVal) return sortOrder === 'asc' ? -1 : 1;
      if (aVal > bVal) return sortOrder === 'asc' ? 1 : -1;
      return 0;
    });

    return sorted;
  };
  const handleExport = () => {
    // Headers - no ID column
    const headers = [
      'Name', 'Category', 'Location', 'Capacity', 'Start Date',
      'Min Duration', 'Max Duration', 'Duration Interval', 'Email Confirmation',
      'Description', 'Features', 'Amenities', 'Security', 'Rates', 'Photo URL'
    ];

    // Rows - no ID column
    const rows = resources.map(resource => {
      const features = Object.entries(resource.details.features)
        .filter(([_, v]) => v.enabled)
        .map(([k, _]) => k.replace(/_/g, ' '))
        .join('; ');

      const amenities = Object.entries(resource.details.amenities)
        .filter(([_, v]) => v.enabled)
        .map(([k, _]) => k.replace(/_/g, ' '))
        .join('; ');

      const security = Object.entries(resource.details.security)
        .filter(([_, v]) => v.enabled)
        .map(([k, _]) => k.replace(/_/g, ' '))
        .join('; ');

      const rates = resource.rates
        .map(r => `${r.price_name}: $${r.price} (${r.renewal_type})`)
        .join('; ');

      return [
        resource.name,
        resource.category,
        resource.location,
        resource.limitations.capacity,
        resource.start_date,
        resource.min_duration,
        resource.max_duration,
        resource.duration_interval,
        resource.email_confirmation ? 'Yes' : 'No',
        resource.details.resourceDetails,
        features,
        amenities,
        security,
        rates,
        resource.image || ''
      ];
    });

    const csvContent = [
      headers.join(','),
      ...rows.map(row => row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(','))
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `resources_export_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showSortMenu && sortMenuRef.current && !sortMenuRef.current.contains(event.target)) {
        setShowSortMenu(false);
      }
      if (showBulkMenu && bulkMenuRef.current && !bulkMenuRef.current.contains(event.target)) {
        setShowBulkMenu(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showSortMenu, showBulkMenu]);

  if (selectedResource) {
    return <ResourceDetail resource={selectedResource} onBack={() => setSelectedResource(null)} onUpdate={fetchResources} />;
  }

  return (
    <div className="flex h-screen overflow-hidden bg-gray-50">
      <Sidebar 
        currentPath="/resources" 
        mobileOpen={mobileSidebarOpen}
        onMobileClose={() => setMobileSidebarOpen(false)}
      />
      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        {/* ── Mobile top bar ── */}
        <header className="md:hidden flex items-center justify-between px-4 py-3 bg-white border-b border-gray-200 sticky top-0 z-30">
          <button
            className="p-2 rounded-md text-gray-600 hover:bg-gray-100 transition-colors"
            onClick={() => setMobileSidebarOpen(true)}
            aria-label="Open menu"
          >
            <Menu className="w-5 h-5" />
          </button>
          <img
            src="/logo.png"
            alt="Optimus Logo"
            className="h-7 w-auto object-contain mr-5"
          />
        </header>

        <main className="flex-1 overflow-y-auto bg-gray-50">
          <div className="p-4 md:p-8">
            <div className="mb-6">
              <h1 className="text-2xl font-semibold text-gray-900 mb-1">Resources</h1>
              <p className="text-sm text-gray-500">
                {loading ? 'Loading resources...' : `${resources.length} resource${resources.length !== 1 ? 's' : ''} found`}
              </p>
            </div>

            <div className="flex flex-wrap items-center justify-between gap-4 mb-6">
              <div className="flex flex-wrap items-center gap-3 flex-1 min-w-0">
                <label className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg bg-white hover:bg-gray-50 cursor-pointer transition-colors">
                  <input
                    type="checkbox"
                    checked={selectedForBulk.length === resources.length && resources.length > 0}
                    onChange={(e) => {
                      if (e.target.checked) {
                        setSelectedForBulk(resources.map(r => r.id));
                      } else {
                        setSelectedForBulk([]);
                      }
                    }}
                    className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500"
                  />
                  <span className="text-sm font-medium text-gray-700 select-none">Select all</span>
                </label>
                <div className="relative" ref={sortMenuRef}>
                  <button
                    onClick={() => setShowSortMenu(!showSortMenu)}
                    className={`flex items-center gap-2 px-4 py-2 border rounded-lg bg-white hover:bg-gray-50 transition-colors ${
                      showSortMenu ? 'border-blue-500 ring-2 ring-blue-100' : 'border-gray-300'
                    }`}
                  >
                    <SlidersHorizontal className="w-4 h-4 text-gray-500" />
                    <span className="text-sm font-medium text-gray-700">Sort</span>
                    <ChevronDown className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${showSortMenu ? 'rotate-180' : ''}`} />
                  </button>

                  {showSortMenu && (
                    <div className="absolute left-0 mt-2 w-56 bg-white border border-gray-200 rounded-lg shadow-lg z-50 py-1 animate-in fade-in slide-in-from-top-1 duration-150">
                      <div className="px-3 py-1.5 text-xs font-semibold text-gray-400 uppercase tracking-wider">Sort by</div>
                      <button onClick={() => { setSortBy('name'); setSortOrder('asc'); setShowSortMenu(false); }}
                        className={`w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center justify-between transition-colors ${sortBy === 'name' && sortOrder === 'asc' ? 'text-blue-600 bg-blue-50/50 font-medium' : 'text-gray-700'}`}>
                        <span>Name (A-Z)</span>
                        {sortBy === 'name' && sortOrder === 'asc' && <Check className="w-4 h-4 text-blue-600" />}
                      </button>
                      <button onClick={() => { setSortBy('name'); setSortOrder('desc'); setShowSortMenu(false); }}
                        className={`w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center justify-between transition-colors ${sortBy === 'name' && sortOrder === 'desc' ? 'text-blue-600 bg-blue-50/50 font-medium' : 'text-gray-700'}`}>
                        <span>Name (Z-A)</span>
                        {sortBy === 'name' && sortOrder === 'desc' && <Check className="w-4 h-4 text-blue-600" />}
                      </button>
                      <button onClick={() => { setSortBy('category'); setSortOrder('asc'); setShowSortMenu(false); }}
                        className={`w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center justify-between transition-colors ${sortBy === 'category' && sortOrder === 'asc' ? 'text-blue-600 bg-blue-50/50 font-medium' : 'text-gray-700'}`}>
                        <span>Category (A-Z)</span>
                        {sortBy === 'category' && sortOrder === 'asc' && <Check className="w-4 h-4 text-blue-600" />}
                      </button>
                      <button onClick={() => { setSortBy('capacity'); setSortOrder('desc'); setShowSortMenu(false); }}
                        className={`w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center justify-between transition-colors ${sortBy === 'capacity' && sortOrder === 'desc' ? 'text-blue-600 bg-blue-50/50 font-medium' : 'text-gray-700'}`}>
                        <span>Capacity (High-Low)</span>
                        {sortBy === 'capacity' && sortOrder === 'desc' && <Check className="w-4 h-4 text-blue-600" />}
                      </button>
                      <button onClick={() => { setSortBy('date'); setSortOrder('desc'); setShowSortMenu(false); }}
                        className={`w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center justify-between transition-colors ${sortBy === 'date' && sortOrder === 'desc' ? 'text-blue-600 bg-blue-50/50 font-medium' : 'text-gray-700'}`}>
                        <span>Newest First</span>
                        {sortBy === 'date' && sortOrder === 'desc' && <Check className="w-4 h-4 text-blue-600" />}
                      </button>
                    </div>
                  )}
                </div>

                <div className="relative flex-1 w-[200px] sm:w-auto max-w-xl">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                  <input
                    type="text"
                    placeholder="Search..."
                    className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
                  />
                </div>
              </div>

              <div className="flex flex-wrap items-center gap-3 ml-4">
                <div className="relative" ref={bulkMenuRef}>
                  <button
                    onClick={() => setShowBulkMenu(!showBulkMenu)}
                    disabled={selectedForBulk.length === 0}
                    className={`flex items-center gap-2 px-4 py-2 border rounded-lg bg-white hover:bg-gray-50 transition-colors ${
                      selectedForBulk.length === 0 
                        ? 'opacity-50 cursor-not-allowed border-gray-200 text-gray-400' 
                        : showBulkMenu
                          ? 'border-blue-500 ring-2 ring-blue-100 text-gray-700 font-medium'
                          : 'border-gray-300 text-gray-700 font-medium'
                    }`}
                  >
                    <Menu className="w-4 h-4 text-gray-500" />
                    <span className="text-sm">Bulk actions</span>
                    {selectedForBulk.length > 0 && (
                      <span className="ml-1 px-2 py-0.5 bg-blue-100 text-blue-700 text-xs rounded-full">
                        {selectedForBulk.length}
                      </span>
                    )}
                    <ChevronDown className={`w-4 h-4 text-gray-400 transition-transform duration-200 ${showBulkMenu ? 'rotate-180' : ''}`} />
                  </button>

                  {showBulkMenu && selectedForBulk.length > 0 && (
                    <div className="absolute right-0 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-50 py-1 animate-in fade-in slide-in-from-top-1 duration-150">
                      <div className="px-3 py-1.5 text-xs font-semibold text-gray-400 uppercase tracking-wider">Actions</div>
                      <button
                        onClick={handleDeleteClick}
                        className="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50 flex items-center gap-2 transition-colors"
                      >
                        <Trash2 className="w-4 h-4 text-red-500" />
                        Delete selected
                      </button>
                    </div>
                  )}
                </div>

                <button
                  onClick={handleExport}
                  className="flex items-center gap-2 px-4 py-2 border border-gray-300 rounded-lg bg-white hover:bg-gray-50"
                >
                  <Download className="w-4 h-4" />
                  <span className="text-sm">Export</span>
                </button>

                <button
                  onClick={() => setShowAddModal(true)}
                  className="flex items-center gap-2 px-4 py-2 bg-[#1A5090] text-white rounded-lg hover:bg-blue-900"
                >
                  <Plus className="w-4 h-4" />
                  <span className="text-sm font-medium">Add Resource</span>
                </button>
              </div>
            </div>

            {loading && (
              <div className="text-center py-12">
                <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
                <p className="mt-2 text-gray-500">Loading resources...</p>
              </div>
            )}

            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg">
                <p className="font-medium">Error loading resources</p>
                <p className="text-sm">{error}</p>
                <button
                  onClick={fetchResources}
                  className="mt-2 text-sm underline hover:no-underline"
                >
                  Try again
                </button>
              </div>
            )}

            {!loading && !error && resources.length === 0 && (
              <div className="text-center py-12 bg-white rounded-lg border border-gray-200">
                <p className="text-gray-500">No resources found</p>
                <button
                  onClick={() => setShowAddModal(true)}
                  className="mt-4 px-4 py-2 bg-[#1A5090] text-white rounded-lg hover:bg-blue-900"
                >
                  <Plus className="w-4 h-4 inline mr-2" />
                  Add your first resource
                </button>
              </div>
            )}

            {!loading && !error && resources.length > 0 && (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {getSortedResources().map((resource) => (
                  <div key={resource.id} className="bg-white rounded-lg shadow-sm overflow-hidden border border-gray-200 hover:shadow-md transition-shadow">
                    <div
                      className="aspect-video bg-gray-200 flex items-center justify-center cursor-pointer"
                      onClick={() => setSelectedResource(resource)}
                    >
                      {resource.image ? (
                        <img
                          src={resource.image}
                          alt={resource.name}
                          className="w-full h-full object-cover"
                          onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'flex';
                          }}
                        />
                      ) : null}
                      <div className="flex flex-col items-center justify-center text-gray-400" style={{ display: resource.image ? 'none' : 'flex' }}>
                        <svg className="w-12 h-12 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                        </svg>
                        <span className="text-sm">No Image</span>
                      </div>
                    </div>

                    <div
                      className="p-4 cursor-pointer"
                      onClick={() => setSelectedResource(resource)}
                    >
                      <h3 className="font-semibold text-gray-900 mb-2">{resource.name}</h3>

                      <div className="space-y-2 mb-4">
                        <div className="flex items-center text-sm text-gray-500">
                          <MapPin className="w-4 h-4 mr-1" />
                          {resource.location}
                        </div>
                      </div>

                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedForBulk(prev =>
                            prev.includes(resource.id)
                              ? prev.filter(id => id !== resource.id)
                              : [...prev, resource.id]
                          );
                        }}
                        className={`w-full py-2 rounded-lg text-sm font-medium transition-colors ${selectedForBulk.includes(resource.id)
                            ? 'bg-blue-100 text-blue-700 border border-blue-300'
                            : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                          }`}
                      >
                        {selectedForBulk.includes(resource.id) ? 'Selected' : 'Select'}
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </main>
      </div>

      <AddResourceModal
        isOpen={showAddModal}
        onClose={() => setShowAddModal(false)}
        onSuccess={fetchResources}
      />

      <DeleteConfirmModal
        isOpen={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onConfirm={handleDeleteConfirm}
        resourceName={deleteResourceInfo.name}
        resourceCount={deleteResourceInfo.count}
      />
    </div>
  );
}